import {Multimedia} from '@/types/matrix';
import {Box, Card, CardMedia} from '@mui/material';

import VideoPreviewWithPlayIcon from '@/components/matrix-chat/ui/video-preview-with-play-icon';
interface BoxWithElementsProps {
  urls: string[];
  multimediaType: Multimedia;
  handleOpenFullScreen: (url: string) => void;
}

const BoxWithElements: React.FC<BoxWithElementsProps> = ({
  urls,
  multimediaType,
  handleOpenFullScreen
}) => {
  const cardProps = {
    height: '100%',
    position: 'relative'
  };

  const cardMediaProps = {
    cursor: 'pointer',
    objectFit: 'cover',
    height: '100%'
  };

  const isVideo = multimediaType === 'video';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        //gap: '5px',
        maxWidth: {xs: '150px', md: '300px'},
        maxHeight: {xs: '75px', md: '150px'}
      }}
    >
      {urls.slice(0, 2).map((url, index) => (
        <Box
          key={url}
          sx={{
            height: {xs: '75px', md: '150px'},
            width: {xs: '75px', md: '150px'}
          }}
        >
          <Card
            // onMouseLeave={handleMouseLeave}
            sx={{...cardProps}}
          >
            {isVideo ? (
              <VideoPreviewWithPlayIcon
                url={url}
                handleOpenFullScreen={handleOpenFullScreen}
              />
            ) : (
              <CardMedia
                component="img"
                image={urls[index]}
                alt={`${multimediaType} ${index + 1}`}
                onClick={() => handleOpenFullScreen(urls[index])}
                sx={{...cardMediaProps}}
              />
            )}
          </Card>
        </Box>
      ))}
    </Box>
  );
};

export default BoxWithElements;
